import { Combobox, Portal } from '@chakra-ui/react';
import { useContext } from 'react';
import { LuX } from 'react-icons/lu';
import { PortalContainerContext } from '../providers/chakra';

const VComboboxRoot = ({ size = 'xs', ...props }: Combobox.RootProps) => (
  <Combobox.Root size={size} {...props} />
);

const VComboboxRootProvider = ({ size = 'xs', ...props }: Combobox.RootProviderProps) => (
  <Combobox.RootProvider size={size} {...props} />
);

const VComboboxClearTrigger = (props: Combobox.ClearTriggerProps) => (
  <Combobox.ClearTrigger {...props}>
    <LuX />
  </Combobox.ClearTrigger>
);

const VComboboxContent = (props: Combobox.ContentProps) => {
  const portalContainerRef = useContext(PortalContainerContext);

  return (
    <Portal container={portalContainerRef ?? undefined}>
      <Combobox.Positioner>
        <Combobox.Content {...props} />
      </Combobox.Positioner>
    </Portal>
  );
};

const VCombobox = {
  Root: VComboboxRoot,
  RootProvider: VComboboxRootProvider,
  Control: Combobox.Control,
  Input: Combobox.Input,
  IndicatorGroup: Combobox.IndicatorGroup,
  ClearTrigger: VComboboxClearTrigger,
  Content: VComboboxContent,
  Item: Combobox.Item,
  Empty: Combobox.Empty,
};

export { createListCollection as createComboboxCollection, useCombobox } from '@chakra-ui/react';
export default VCombobox;
